import { render, staticRenderFns } from "./TodoListcard.vue?vue&type=template&id=52c76922&"
import script from "./TodoListcard.vue?vue&type=script&lang=js&"
export * from "./TodoListcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports